/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
export const usePaymentId = () => {
  const urlParams = new URLSearchParams(window.location.search);
  let paymentId = urlParams.get('paymentId');
  let message = urlParams.get('message');

  if (paymentId) {
    paymentId = String(paymentId).trim();
  }
  if (message) {
    message = String(message).trim();
  }
  return {
    paymentId,
    message,
  };
};
